import React from "react";
import { fetchPrivacyPolicy } from "../../Services/privacy_policy";
import { useQuery } from "@tanstack/react-query";
import logo from "../../assets/Images/Frame 45.png";
import {
  ContentContainer,
  Logo,
  LogoContainer,
  PageWrapper,
} from "../../Styles/CommonStyle";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Import styles
import { Skeleton } from "antd";

function PrivacyPolicyPage() {
  const { data, isLoading } = useQuery({
    queryKey: ["privacyPolicy"],
    queryFn: fetchPrivacyPolicy,
    refetchOnWindowFocus: false,
    retry: false,
  });

  return (
    <PageWrapper>
      <LogoContainer>
        <Logo src={logo} alt="Logo" />
      </LogoContainer>

      <ContentContainer>
        
        { isLoading && <Skeleton />}
        {data?.length && (
          // <div dangerouslySetInnerHTML={{ __html: data[0].value }} />
          <ReactQuill value={data[0].value} readOnly={true} theme="bubble" />
        )}
      </ContentContainer>
    </PageWrapper>
  );
}

export default PrivacyPolicyPage;
